import React from "react";
import { processSteps } from "../mock";
import { ArrowRight } from "lucide-react";

const Process = () => {
  return (
    <section id="process" className="py-24 relative">
      <div className="absolute inset-0 circuit-dots opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80">
            Διαδικασία
          </div>
          <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
            Πώς <span className="text-emerald-400">δουλεύουμε</span>
          </h2>
          <p className="mt-4 text-emerald-50/70">
            Ένας απλός, διαφανής τρόπος για να επαναφέρετε τη συσκευή σας.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {processSteps.map((p, i) => (
            <div key={p.num} className="relative pcb-card p-6 reveal">
              <div className="text-5xl font-extrabold text-emerald-500/15 absolute right-4 top-3">
                {p.num}
              </div>
              <div className="relative">
                <div className="text-emerald-400 font-mono text-sm">{`STEP ${p.num}`}</div>
                <h3 className="mt-2 text-xl font-bold text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-emerald-50/70 leading-relaxed">
                  {p.desc}
                </p>
              </div>
              {i < processSteps.length - 1 && (
                <ArrowRight className="hidden lg:block absolute -right-5 top-1/2 -translate-y-1/2 w-6 h-6 text-emerald-500/60 z-10" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
